import Icon from "../../../../components/atoms/Icon";
import { PaidServiceAvailabilityStatus } from "./useFetchPaidServiceAvailabilities";

type Props = {
  title: string;
  description: string;
  status: PaidServiceAvailabilityStatus;
  canEnable: boolean;
  canDisable: boolean;
  trialApplicationUrl?: string;
  onEnable: () => void;
  onDisable: () => void;
};

const getStatusLabel = (
  status: PaidServiceAvailabilityStatus,
): string | null => {
  switch (status) {
    case "pre_trial_on":
    case "before_trial_on":
    case "trial_on":
    case "paid_on":
    case "after_trial_on":
      return "利用中";
    case "pre_trial_off":
      return "トライアルに申し込み";
    case "before_trial_off":
      return "トライアル期間前";
    case "after_trial_off":
      return "トライアル済";
    default:
      return null;
  }
};

export const PaidServiceItem = ({
  title,
  description,
  status,
  canEnable,
  canDisable,
  trialApplicationUrl,
  onEnable,
  onDisable,
}: Props) => {
  const statusLabel = getStatusLabel(status);
  const isActive =
    status === "trial_on" ||
    status === "paid_on" ||
    status === "after_trial_on" ||
    status === "pre_trial_on" ||
    status === "before_trial_on";
  const isPreTrial = status === "pre_trial_off";
  const showInlineStatus =
    statusLabel && !isActive && !canEnable && !isPreTrial;

  return (
    <div className="flex flex-col gap-[0.8rem] rounded-[0.6rem] border border-solid border-gray-400 p-[1.6rem]">
      <div className="flex items-center gap-[1.6rem]">
        <p className="text-[1.6rem] font-bold leading-[1.5] text-black">
          {title}
        </p>
        {showInlineStatus && (
          <div className="flex items-center justify-center rounded-[0.4rem] bg-gray-100 px-[0.8rem] py-[0.8rem] text-[1.4rem] font-bold text-blue-400">
            {statusLabel}
          </div>
        )}
      </div>
      <p className="text-[1.4rem] leading-[1.5] text-black">{description}</p>
      {isPreTrial && trialApplicationUrl && (
        <div className="flex w-fit items-center justify-center rounded-[0.4rem] bg-gray-100 p-[0.8rem]">
          <a
            href={trialApplicationUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-[0.4rem] text-[1.4rem] font-bold text-blue-400 underline hover:no-underline"
          >
            {title}のトライアルに申し込む
            <Icon
              name="icon-external-link"
              className="h-[2rem] w-[2rem]"
              color="primary"
            />
          </a>
        </div>
      )}
      {canEnable && (
        <button
          type="button"
          className="w-fit cursor-pointer rounded-full border border-solid border-blue-400 bg-white px-[1.6rem] py-[1rem] text-[1.4rem] font-bold text-blue-400 hover:bg-blue-200"
          onClick={onEnable}
        >
          {title}を追加する
        </button>
      )}
      {canDisable && (
        <div className="flex items-center gap-[1.6rem]">
          <div className="flex items-center justify-center rounded-[0.4rem] bg-blue-200 px-[1.6rem] py-[1rem] text-[1.4rem] font-bold text-blue-400">
            利用中
          </div>
          <button
            type="button"
            className="cursor-pointer border-none bg-transparent p-0 text-[1.2rem] font-bold text-blue-400 underline hover:no-underline"
            onClick={onDisable}
          >
            利用を停止
          </button>
        </div>
      )}
    </div>
  );
};
